module.exports = __webpack_public_path__ + "img/IRL.6fde512f.svg";